import { Route, Switch, useRouteMatch } from 'react-router-dom';
import React from 'react';
import { ArrivalsView } from './arrivals.view';
import { DriverArrivalsView } from './driverArrivals.view';

/**
 * Routeur pour la gestion des arrivées
 * 
 * Ce routeur gère la navigation entre :
 * - Vue des arrivées standard (/arrivals)
 * - Vue des arrivées pour les chauffeurs (/driver-arrivals)
 * 
 * Logique métier :
 * - Routage conditionnel selon le chemin
 * - Composants spécialisés selon le contexte d'utilisation
 * - Support des deux types d'utilisateurs (admin et chauffeur)
 * 
 * @returns Composant React du routeur des arrivées
 */
export const ArrivalsRouter = () => {
  let { path } = useRouteMatch();

  return (
    <div>
      <Switch>
        <Route exact path={path}>
          {path === "/arrivals" && <ArrivalsView />}
          {path === "/driver-arrivals" && <DriverArrivalsView />}
        </Route>
      </Switch>
    </div>
  );
};
